import { render, staticRenderFns } from "./GroupWorkdayForm.vue?vue&type=template&id=61747d31&scoped=true"
import script from "./GroupWorkdayForm.vue?vue&type=script&lang=js"
export * from "./GroupWorkdayForm.vue?vue&type=script&lang=js"
import style0 from "./GroupWorkdayForm.vue?vue&type=style&index=0&id=61747d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61747d31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VIcon,VSwitch,VTextField})
